import { getSessionLableList } from "../../../http/EmailManagement.js";
import { getListSessionLable, getHotPointList } from "../../../http/SessionLableManagement.js";

const sessionLabData = {
  selectedLablist: [],
  hotSelected: [],
  selectedList: '',
  vdnId: JSON.parse(LocalStorage.getItem("obj"))?JSON.parse(LocalStorage.getItem("obj")).vdnId:'',
  props: { 
    multiple: true,
    label: 'labName',
    value: 'labName'
  },
  optionsList: [],
  hotPointList: [],
  hotPointListBak: [],
  labelActive: '2',
  searchVal: '',
  isSearch: false,
  remark: '',
}

const sessionLabMethod = {
  //搜索
  handleSearchFn() {
    const self = this
    self.hotPointList = self.hotPointListBak.filter(item => {
      return item.labName.indexOf(self.searchVal.trim())>-1
    })
  },
  //标签数据回填
  formatsessLabPath() {
    const self = this
    self.selectedList = ''
    self.selectedLablist = []
    self.hotSelected = []
    self.remark = '';
    let formatArray = []
    if (self.sessLabPath&&self.sessLabPath.length) {
      self.sessLabPath.map(item => {
        self.selectedList += item.LabPath + ';'
        formatArray.push(item.LabPath.split('>'));
        self.remark = item.remark;
      })
    }
    if (self.labelActive==1) self.selectedLablist = formatArray
    if (self.labelActive==2) self.formatHotLab(2)
  },
  //普通标签选择
  handleChangeFn(value) {
    const self = this
    self.selectedList = ''
    if (value.length) {
      value.map(item => {
        item.map((item2, index) => {
          if (item.length == (index+1)) self.selectedList += item2 + ';'
          else self.selectedList += item2 + '>'
        })
      })
    }
  },
  //热点标签选择
  hotLabelFn(event, item) {
    const self = this
    if (event) {
      self.selectedList += item.namePath + ';'
    } else {
      var reg = new RegExp(item.namePath + ';', 'g')
      var result = self.selectedList.replace(reg, '')
      self.selectedList = result
    }
  },
  formatHotLab(type) {
    const self = this
    let selectedLablist1 = [],selectedLablist2 = []
    let splitlist = self.selectedList.split(';').filter(item => { return item })
    splitlist.map(item => {
      var strArry = item.split('>')
      if (type==1) selectedLablist1.push(strArry)
      if (type==2) {
        strArry = strArry[strArry.length-1]
        var obj = self.hotPointList.filter(item2 => { return item2.namePath == item })
        if (obj.length) selectedLablist2.push({id: obj[0].id, labName: strArry})
      }
    })
    if (type == 1) self.selectedLablist = selectedLablist1
    else {
      self.hotSelected = []
      selectedLablist2.map(item => {
        self.hotPointList.map(item2 => {
          if (item2.id==item.id) self.hotSelected.push(item.labName+item.id)
        })
      })
    }
  },
  //保存、取消
  handleComitFn(type) {
    const self = this
    let selectedIds = []
    let selectedLablist = []
    let splitlist = self.selectedList.split(';').filter(item => { return item })
    splitlist.map(item => {
      var strArry = item.split('>')
      selectedLablist.push(strArry)
    })
    selectedLablist.map(item => {
      var obj = self.findObjByLabname(item[0], item[item.length-1])
      selectedIds.push(obj[0].id)
    })
    if (type==1) self.$emit('submitLabFn', type,  self.selectedList, selectedIds, this.remark)
    if (type==2) {
      if (self.pageType) self.$emit('submitLabFn', type)
      else self.formatsessLabPath()
    }
  },
  //获取普通标签
  fetchSessionLableList() {
    const self = this
    getSessionLableList({
      vdnId: JSON.parse(LocalStorage.getItem("obj")).vdnId,
      labName: ''
    }).then(res => {
      if (res && res.retCode == 1) {
        self.optionsList = self.getTreeData(res.data)
      }
    })
  },
  //获取热点标签
  fetchHotPointList() {
    const self = this
    getHotPointList({
      vdnId: JSON.parse(LocalStorage.getItem("obj")).vdnId,
      labName: ''
    }).then(res => {
      if (res && res.retCode == 1) {
        self.hotPointList = res.data
        self.hotPointListBak = res.data
        self.formatsessLabPath()
      }
    })
  },
  //剔除children空数组
  getTreeData(data) {
    for (var i = 0; i < data.length; i++) {
      if (data[i].children.length < 1) {
        // children若为空数组，则将children设为undefined
        data[i].children = undefined;
      } else {
        // children若不为空数组，则继续 递归调用 本方法
        this.getTreeData(data[i].children);
      }
    }
    return data;
  },
  findObjByLabname(v1, v2) {
    const self = this
    var returnStr = []
    var find = function(arr, value){
      arr.forEach(item => {
        if(item.labName==value&&!item.children) {  
          returnStr.push(item)
        } else if(item.children) {
          find(item.children, value)                    
        }                   
      })
    }
    self.optionsList.map(item => {
      if (item.labName == v1) {
        var arry = []
        arry.push(item)
        find(arry, v2)
      }
    })
    return returnStr
  },
}

export { sessionLabData, sessionLabMethod }


// WEBPACK FOOTER //
// ./src/views/components/js/SessionLab.js